(function($, Drupal) {

  Drupal.behaviors.msg_zipbasket = {
    attach: function (context, settings) {

        $('.zipbasket-link').once("msg_zipbasket").msgZipbasket({
            datasource: 'link',
            afterAdded: function(){ funcTransInOut(); }
        });
        var funcTransInOut = function(){
            $('#msg_zipbasket .mzb_list_wrapper').slideDown();
            setTimeout( function(){$('#msg_zipbasket .mzb_list_wrapper').slideUp();},2000);
        };
    }
  }

})(jQuery, Drupal);